
import { Component, Vue } from 'vue-property-decorator'
import { queryChartData } from '@/api/query'
import { drawCompanyRechargehart } from '@/charts/company/recharge_line'
import { drawCompanySpendingehart } from '@/charts/company/spending_line'
import echart, { ECharts } from 'echarts'

@Component({
  name: 'CompanyChart'
})
export default class extends Vue {
  private loading = false
  private requestId = 0

  private rechargeLineChart: ECharts | null = null
  private rechargeLineChartData: any[] = []

  private spendingLineChart: ECharts | null = null
  private spendingLineChartData: any[] = []

  private resizeHandler = () => {
    if (this.rechargeLineChart) {
      this.rechargeLineChart.resize()
    }
    if (this.spendingLineChart) {
      this.spendingLineChart.resize()
    }
  }

  mounted() {
    this.rechargeLineChart = this.createChart(this.$refs.rechargeLineChartRef as HTMLDivElement)
    this.spendingLineChart = this.createChart(this.$refs.spendingLineChartRef as HTMLDivElement)
    window.addEventListener('resize', this.resizeHandler)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.rechargeLineChart) {
      this.rechargeLineChart.dispose()
      this.rechargeLineChart = null
    }
    if (this.spendingLineChart) {
      this.spendingLineChart.dispose()
      this.spendingLineChart = null
    }
  }

  public async fetchChartsData(filters: any, id: any) {
    const currentRequestId = ++this.requestId
    this.loading = true
    try {
      const [rechargeLineChartData, spendingLineChartData] = await Promise.all([
        queryChartData(`/counts/company/${id}/recharge/line`, filters),
        queryChartData(`/counts/company/${id}/spending/line`, filters)
      ])

      if (currentRequestId !== this.requestId) {
        return
      }

      this.rechargeLineChartData = rechargeLineChartData || []
      this.spendingLineChartData = spendingLineChartData || []
      this.drawCharts(filters)
    } finally {
      if (currentRequestId === this.requestId) {
        this.loading = false
      }
    }
  }

  private drawCharts(filters: any) {
    drawCompanyRechargehart(
      this.rechargeLineChart as ECharts,
      this.rechargeLineChartData,
      filters
    )
    drawCompanySpendingehart(
      this.spendingLineChart as ECharts,
      this.spendingLineChartData,
      filters
    )
  }

  private createChart(element: HTMLDivElement) {
    return echart.getInstanceByDom(element) || echart.init(element)
  }
}
